import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GenericObject } from 'src/app/interfaces/generic-object';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';
import { VendorService } from 'src/app/services/vendor.service';

@Component({
  selector: 'app-admin-vendor-documents',
  templateUrl: './admin-vendor-documents.component.html',
  styleUrl: './admin-vendor-documents.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminVendorDocumentsComponent implements OnDestroy {
  constructor(
    private ToastService: ToastService,
    private VendorService: VendorService,
    private SharedDataService: SharedDataService,
    private UtilityService: UtilityService
  ) {
    this.SharedDataServiceSubscription =
      this.SharedDataService.listenForEvent<number>().subscribe({
        next: ({ eventName, data }) => {
          if (eventName === 'SetVendorId' && typeof data === 'number') {
            this.VendorId = data;

            this.suppliedGridQuery = {
              VendorId: data
            };

            this.VendorService.getVendorV2(
              this.VendorId,
              this.UtilityService.stringifyObjectsInQueryObject({
                attributes: ['id', 'legalName']
              })
            ).subscribe({
              next: (Vendor) => {
                const { legalName } = Vendor;

                if (!legalName) {
                  throw this.ToastService.addErrorToast(
                    'Error',
                    'Vendor is missing legal name.',
                    { returnError: true }
                  );
                }

                this.SharedDataService.sendEvent(
                  'SetTitle',
                  `Documents - ${legalName}`
                );
              }
            });
          }
        }
      });

    this.SharedDataService.sendEvent('GetVendorId');
  }

  VendorId?: number;

  SharedDataServiceSubscription: Subscription;
  suppliedGridQuery?: GenericObject;

  ngOnDestroy(): void {
    if (this.SharedDataServiceSubscription) {
      this.SharedDataServiceSubscription.unsubscribe();
    }
  }
}
